let cleanup = null;

function initSidebarMenu() {
  const nav = document.querySelector('.sidebar-menu');
  if (!nav) return;

  if (cleanup) {
    cleanup();
    cleanup = null;
  }

  const isMobile = window.matchMedia('(max-width: 740px)').matches;

  if (isMobile && nav.hasAttribute('data-mobile-sticky')) {
    const pill = document.querySelector('.location-pill-mobile');
    if (pill) pill.after(nav);
  }

  nav.classList.add('is-ready');

  const links = [...nav.querySelectorAll('.sidebar-menu__link')];
  const anchors = links
    .map(link => {
      const hash = link.getAttribute('href');
      if (!hash?.startsWith('#')) return null;
      const el = document.getElementById(hash.slice(1));
      return el ? { hash, el, link } : null;
    })
    .filter(Boolean);

  if (anchors.length === 0) return;

  function getHeaderHeight() {
    const section = document.querySelector('.shopify-section--header');
    return section ? section.offsetHeight : 0;
  }

  function scrollToAnchor(el) {
    const top = el.getBoundingClientRect().top + window.scrollY - getHeaderHeight();
    window.scrollTo({ top, behavior: 'smooth' });
  }

  function setActive(hash) {
    for (const link of links) {
      const active = link.getAttribute('href') === hash;
      link.classList.toggle('is-active', active);
      if (active && isMobile) {
        link.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      }
    }
  }

  let scrollLocked = false;

  function updateFromScroll() {
    if (scrollLocked) return;
    const threshold = getHeaderHeight() + 40;
    let active = anchors[0].hash;

    for (const { hash, el } of anchors) {
      if (el.getBoundingClientRect().top <= threshold) {
        active = hash;
      }
    }

    const atBottom = (window.innerHeight + Math.ceil(window.scrollY)) >= document.documentElement.scrollHeight;
    if (atBottom) active = anchors[anchors.length - 1].hash;

    setActive(active);
  }

  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateFromScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  function onClick(e) {
    const link = e.currentTarget;
    const hash = link.getAttribute('href');

    e.preventDefault();
    setActive(hash);
    history.pushState(null, '', hash);

    const target = document.getElementById(hash.slice(1));
    if (target) {
      scrollLocked = true;
      scrollToAnchor(target);
      setTimeout(() => { scrollLocked = false; }, 800);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  for (const link of links) {
    link.addEventListener('click', onClick);
  }

  setActive(window.location.hash || anchors[0].hash);
  requestAnimationFrame(updateFromScroll);

  cleanup = () => {
    window.removeEventListener('scroll', onScroll);
    for (const link of links) {
      link.removeEventListener('click', onClick);
    }
  };
}

document.addEventListener('DOMContentLoaded', initSidebarMenu);

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initSidebarMenu);
  document.addEventListener('shopify:section:unload', initSidebarMenu);
  document.addEventListener('shopify:block:select', initSidebarMenu);
  document.addEventListener('shopify:block:deselect', initSidebarMenu);
}
